import { render, staticRenderFns } from "./FunnelTable.vue?vue&type=template&id=1f115658&scoped=true"
import script from "./FunnelTable.vue?vue&type=script&lang=js"
export * from "./FunnelTable.vue?vue&type=script&lang=js"
import style0 from "./FunnelTable.vue?vue&type=style&index=0&id=1f115658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f115658",
  null
  
)

export default component.exports